import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { Program } from "../../types/program";
import { replaceHarvardWithIvyLeague } from "../../utils/utils";
import ProgramHighlights from "../futureceo/ProgramHighlights";
import WhyJoin from "../futureceo/WhyJoin";
import CTA from "../futureceo/CTA";
import { futureCEOConfigs } from "../../data/futureCEOConfigs";

interface ProgramFeaturesProps {
  program: Program;
}

const ProgramFeatures: React.FC<ProgramFeaturesProps> = ({ program }) => {
  // If this is the Future CEO program, render the dedicated FutureCEO blocks
  if ((program as any)?.slug === "future-ceo") {
    return (
      <div>
        <ProgramHighlights config={futureCEOConfigs["harvard"]} />
        <WhyJoin config={futureCEOConfigs["harvard"]} />
        <CTA config={futureCEOConfigs["harvard"]} />
      </div>
    );
  }

  // Default rendering for other programs
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.2 }}
    >
      <h2 className="text-3xl font-bold text-gray-900 mb-8">
        Program Features
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {program.features.map((feature, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.1 * index }}
            className="flex items-start space-x-4 p-6 bg-white rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow"
          >
            <div className="flex-shrink-0">
              <CheckCircle className="h-6 w-6 text-green-500" />
            </div>
            <div>
              <h3 className="font-semibold text-gray-900 mb-1">
                {replaceHarvardWithIvyLeague(feature)}
              </h3>
              <p className="text-gray-600 text-sm">
                Comprehensive coverage of{" "}
                {replaceHarvardWithIvyLeague(feature).toLowerCase()} with expert
                guidance.
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
};

export default ProgramFeatures;
